import { useEffect, useRef, useState } from 'react';
// import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, useMapEvent } from 'react-leaflet';
import MapControlls from './MapControlls';
import MapMarker from './MapMarker';
import { isMobileFunc } from '@helper/functions';
import provincesData from '@constants/CityData.json';
import AutoComplete from './AutoComplete';
import { LoaderBtn } from '../../loading/Loader';

export default function Step3({ formikSignUpRealestate, setStep, loading }) {
  const mapRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileFunc());
  }, []);

  const zoomOfmap = isMobile ? 10 : 11;

  function LocationMarker() {
    useMapEvent('click', (event) => {
      mapRef.current.flyTo(event.latlng, 18, {
        animate: true,
        duration: 0.5,
      });
      setSelectedPosition(event.latlng);
      formikSignUpRealestate.setFieldValue('Coordinate', event.latlng);
    });

    return selectedPosition ? <MapMarker position={selectedPosition} mapRef={mapRef} /> : null;
  }

  const filterCity = formikSignUpRealestate.values.province
    ? provincesData.find((item) => item.province === formikSignUpRealestate.values.province)?.cities
    : [];

  return (
    <form
      onSubmit={formikSignUpRealestate.handleSubmit}
      className="grid grid-cols-2 lg:grid-cols-4 gap-x-2 gap-y-8 lg:gap-x-3 lg:gap-y-10 w-full max-w-[650px]"
    >
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-2">
        <AutoComplete
          name="province"
          title="استان"
          placeholder="استان را وارد کنید"
          data={provincesData}
          required={true}
          value={formikSignUpRealestate.values.province || ''}
          errors={formikSignUpRealestate.errors.province}
          touched={formikSignUpRealestate.touched.province}
          handleBlur={formikSignUpRealestate.handleBlur}
          setFieldValue={formikSignUpRealestate.setFieldValue}
        />
      </div>

      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-2">
        <AutoComplete
          name="city"
          title="شهر"
          placeholder="شهر را وارد کنید"
          data={filterCity}
          required={true}
          value={formikSignUpRealestate.values.city || ''}
          errors={formikSignUpRealestate.errors.city}
          touched={formikSignUpRealestate.touched.city}
          handleBlur={formikSignUpRealestate.handleBlur}
          setFieldValue={formikSignUpRealestate.setFieldValue}
        />
      </div>

      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-4">
        <label className="text-sm lg:text-base" htmlFor="">
          آدرس آژانس
        </label>
        <input
          name="address"
          onChange={formikSignUpRealestate.handleChange}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.address || ''}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.address && formikSignUpRealestate.touched.address
              ? 'border-error'
              : 'border-blackFont-200 focus:border-blackFont-900'
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light h-[54px]`}
          placeholder="آدرس دقیق را وارد کنید"
          type="text"
        />
      </div>

      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-4">
        <label className="text-sm lg:text-base" htmlFor="">
          موقعیت آژانس
        </label>
        <div className="h-[200px] rounded-lg relative w-full overflow-hidden z-0">
          <MapControlls mapRef={mapRef} />
          <MapContainer
            ref={mapRef}
            center={selectedPosition || [35.6892, 51.389]}
            zoom={14.5}
            style={{ height: '100%', zIndex: 10 }}
            doubleClickZoom={false}
            dragging={true}
            scrollWheelZoom={true}
            zoomControl={false}
            whenReady={(mapInstance) => {
              mapRef.current = mapInstance.target;
              mapInstance.target.flyTo([35.8, 51.454], zoomOfmap, {
                duration: 1.5,
              });
            }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <LocationMarker />
          </MapContainer>
        </div>
      </div>

      <div className="flex w-full items-center gap-4 col-span-2 lg:col-span-1">
        <button disabled={loading} type="submit" className="btn btn-primary w-full lg:w-fit">
          {loading ? <LoaderBtn /> : 'تایید و ادامه'}
        </button>
        <button onClick={() => setStep(2)} className="btn border-[1px] border-primary text-primary w-full lg:w-fit">
          مرحله قبل
        </button>
      </div>
    </form>
  );
}
